
import { defineComponent } from 'vue'
import { featureMap, FeatureType } from '~/types/features'

export default defineComponent({
  name: 'UpgradeFeature',

  props: {
    featureShortcode: {
      type: String as () => FeatureType,
      required: true
    }
  },

  computed: {
    planName(): string | undefined {
      return featureMap[this.featureShortcode]?.minRequiredPlan
    },

    featureName(): string | undefined {
      return featureMap[this.featureShortcode]?.title
    }
  }
})
